import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppFooterComponent } from 'src/domains/theme/app/component/app-footer/app-footer.component';
import { AppHeaderComponent } from 'src/domains/theme/app/component/app-header/app-header.component';

@Component({
  selector: 'app-main-page-layout',
  templateUrl: './main-page-layout.component.html',
  styleUrls: ['./main-page-layout.component.scss'],
  imports: [AppHeaderComponent, AppFooterComponent, RouterOutlet],
})
export class MainPageLayoutComponent {}
